export default __webpack_public_path__ + "static/media/app-store-badge.bc9fa1ce.png";